export const SET_LOCALE = "SET_LOCALE";
export const LOCALE_EN = "en";
export const LOCALE_EN_TITLE = "EN";
export const LOCALE_KH = "km";
export const LOCALE_KH_TITLE = "ខ្មែរ";